<template>

        <div class="o-modal__formFields">
            <span class="o-modal__formTitle u-fs30 u-fw700 u-dBlock u-lh125 u-c<?= $pcColor; ?>">{{ calculator }}</span>

            <form>
                
                <div class="o-modal__formOverlay"></div>

                <div class="o-modal__selectFields">

                    <div>
                        <label for="calculator-food">{{ voeding }}</label>
                        <div class="ginput_container_select">
                            <select name="calculator-food" id="calculator-food" v-model="selectedProductID">
                                <option value="">- {{ voeding }} -</option>
                                <option v-for="product in productData" :key="product.product_id" :value="product.product_id">
                                    {{ product.product }}
                                </option>
                            </select>
                        </div>
                    </div>

                    <template v-if="! selectedProductID">
                        <div>
                            <div class="o-modal__emptySelect">
                                <label>{{ gewicht }}</label>
                                <span>Selecteer voeding</span>
                            </div>
                        </div>
                    </template>
                    <template v-else-if="selectedProduct.feeding_guide_age">

                        <div>
                            <label for="calculator-age">{{ leeftijd }}</label>
                            <div class="ginput_container_select">
                                <select name="calculator-age" id="calculator-age" v-model="selectedAge">
                                    <option value="">- {{ leeftijd }} -</option>
                                    <option v-for="( item, index ) in selectedProduct.feeding_guide_age" :key="`${selectedProductID}-age-${index}`">
                                        {{ item.age }}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div>
                            <template v-if="selectedAge.includes( '9+' )">
                                <div class="o-modal__notice">
                                    <label>&nbsp;</label>
                                    <span>Zie Cavom compleet</span>
                                </div>
                            </template>
                            <template v-else-if="selectedAge">
                                <label for="calculator-weight">{{ gewicht }}</label>
                                <div class="ginput_container_select">
                                    <select name="calculator-weight" id="calculator-weight" v-model="selectedAgeWeight">
                                        <option value="">- {{ gewicht }} -</option>
                                        <option v-for="( weight, index ) in selectedProduct.feeding_guide_age_weight" :key="`${selectedProductID}-age-weight-${index}`">
                                            {{ weight }}
                                        </option>
                                    </select>
                                </div>
                            </template>
                            <template v-else>
                                <div class="o-modal__emptySelect">
                                    <label>{{ gewicht }}</label>
                                    <span>Selecteer leeftijd</span>
                                </div>
                            </template>
                        </div>

                    </template>
                    <template v-else>
                        
                        <div>
                            <label for="calculator-weight">{{ gewicht }}</label>
                            <div class="ginput_container_select">
                                <select name="calculator-weight" id="calculator-weight" v-model="selectedWeight">
                                    <option value="">- {{ gewicht }} -</option>
                                    <option v-for="( item, index ) in selectedProduct.feeding_guide_weight" :key="`${selectedProductID}-weight-${index}`">
                                        {{ item.weight }}
                                    </option>
                                </select>
                            </div>
                        </div>

                    </template>

                </div>
                
            </form>

            <div v-if="selectedAmount" class="o-modal__disc">
                <div>
                    <span>{{ defDisclaimer[language] }}</span>
                </div>
                <div v-if="productDisclaimer" class="o-modal__discSpace">
                    <span>{{ productDisclaimer }}</span>
                </div>
                <div>
                    <span class="o-modal__discBottom">{{ defDisclaimerBottom[language] }}</span>
                </div>
            </div>

        </div>

        <div class="o-modal__formResult u-bgLight" :class="resultClass">
            <div v-if="selectedAmount" class="o-modal__formResultInner">
                <span class="u-fs40 u-fw700">{{ selectedProduct.product }}</span>
                <span class="u-fs30 u-fw500">{{ selectedAmount.amount }}</span>
                <a v-if="selectedProductURL" class="a-button" :href="selectedProductURL" :title="view">{{ view }}</a>
            </div>
            <div v-else class="o-modal__formResultEmpty">
                <span class="u-fs22">
                    {{ choice }}
                </span>
            </div>
        </div>

</template>
<script setup>

    import { ref, watch, computed } from 'vue';

    const calculator = window?.i18n?.calculator || '';
    const gewicht = window?.i18n?.gewicht || '';
    const voeding = window?.i18n?.voeding || '';
    const leeftijd = window?.i18n?.leeftijd || '';
    const language = window?.i18n?.lang || '';
    const choice = window?.i18n?.choice || '';
    const view = window?.i18n?.view || '';

    const color = window?.i18n?.color || '';
    const rawTitle = window?.i18n?.title || '';

    const geenResultaten = window?.i18n?.geenResultaten || '';
    const berekenen = window?.i18n?.berekenen || '';
    
    function multiplyFeedingAmount(amount, multiplier) {

        // Remove the 'gr' part and split the string by ' - '
        const amounts = amount.replace('gr', '').split(' - ');
        
        // Multiply each value by the multiplier
        const min = parseFloat(amounts[0]) * multiplier;
        const max = parseFloat(amounts[1]) * multiplier;
        
        // Return the result in the same format
        return `${min} - ${max}gr`;
    }

    const defDisclaimer = {
            "nl": "De benodigde hoeveelheid hangt o.a. af van ras leeftijd en de activiteit van uw hond. Verdeel de hoeveelheid voer over 2 maaltijden per dag. Deze waarde is een richtlijn die u zo nodig dient aan te passen.",
            "en": "The required amount depends on factors such as breed, age, and activity level of your dog. Divide the amount of food into 2 meals per day. This value is a guideline that should be adjusted as needed.",
            "de": "Die benötigte Menge hängt unter anderem von der Rasse, dem Alter und der Aktivität Ihres Hundes ab. Teilen Sie die Futtermenge auf 2 Mahlzeiten pro Tag auf. Dieser Wert ist eine Richtlinie, die bei Bedarf angepasst werden sollte."
        };

    const defDisclaimerBottom = {
            "nl": "Zorg altijd voor voldoende vers drinkwater.",
            "en": "Always ensure there is plenty of fresh drinking water available.",
            "de": "Sorgen Sie immer für ausreichend frisches Trinkwasser.",
        };

    const productData = [
        {
            "product": "Cavom compleet pup/junior", 
            "product_id": "compleet-pup-junior",
            "color": "dark-red",
            "feeding_guide_age": [
                { "age": "1 - 3 maand", "amount": "35 - 50gr", "bowls": 4 },
                { "age": "3 - 4 maand", "amount": "30 - 40gr", "bowls": 3 },
                { "age": "4 - 6 maand", "amount": "25 - 35gr", "bowls": 3 },
                { "age": "6 - 9 maand", "amount": "15 - 25gr", "bowls": 3 },
                { "age": "9+ maand", "amount": "Zie Cavom compleet" }
            ],
            "feeding_guide_age_weight" : [
                "0.5 kg",
                "1 kg",
                "2 kg",
                "3,5 kg",
                "5 kg",
                "7.5 kg",
                "10 kg",
                "15 kg",
                "20 kg",
                "30 kg",
            ],
            "disclaimer": {
                "nl": "Verdeel de totale hoeveelheid over meerdere maaltijden per dag. De eerste dagen kunt u de brokken tot een dun papje weken met melk, daarna karnemelk of water. Na een paar weken geen vocht meer toevoegen.",
                "en": "Divide the total amount into multiple meals per day. For the first few days, you can soak the kibble into a thin porridge with milk, then switch to buttermilk or water. After a few weeks, stop adding liquid.",
                "de": "Teilen Sie die Gesamtmenge auf mehrere Mahlzeiten pro Tag auf. In den ersten Tagen können Sie die Kroketten mit Milch zu einem dünnen Brei einweichen, dann mit Buttermilch oder Wasser. Nach ein paar Wochen kein Flüssigkeit mehr hinzufügen."
            }
        },
        {
            "product": "Cavom compleet adult",
            "product_id": "compleet",
            "color": "green",
            "feeding_guide_weight": [
                { "weight": "1.0 kg", "amount": "20 - 40gr", "bowls": "2" },
                { "weight": "5.0 kg", "amount": "75 - 115gr", "bowls": "2" },
                { "weight": "10.0 kg", "amount": "130 - 190gr", "bowls": "2" },
                { "weight": "15.0 kg", "amount": "175 - 255gr", "bowls": "2" },
                { "weight": "20.0 kg", "amount": "220 - 315gr", "bowls": "2" },
                { "weight": "30.0 kg", "amount": "305 - 420gr", "bowls": "2" },
                { "weight": "40.0 kg", "amount": "380 - 510gr", "bowls": "2" },
                { "weight": "50.0 kg", "amount": "450 - 600gr", "bowls": "2" },
                { "weight": "60.0 kg", "amount": "520 - 685gr", "bowls": "2" },
                { "weight": "70.0 kg", "amount": "585 - 765gr", "bowls": "2" },
                { "weight": "80.0 kg", "amount": "650 - 845gr", "bowls": "2" },
                { "weight": "90.0 kg", "amount": "710 - 920gr", "bowls": "2" }
            ],
        },
        {
            "product": "Cavom compleet senior",
            "product_id": "compleet-senior",
            "color": "dark-blue",
            "feeding_guide_weight": [
                { "weight": "1.0 kg", "amount": "20 - 40gr", "bowls": 2 },
                { "weight": "5.0 kg", "amount": "75 - 115gr", "bowls": 2 },
                { "weight": "10.0 kg", "amount": "130 - 190gr", "bowls": 2 },
                { "weight": "15.0 kg", "amount": "175 - 255gr", "bowls": 2 },
                { "weight": "20.0 kg", "amount": "220 - 315gr", "bowls": 2 },
                { "weight": "30.0 kg", "amount": "305 - 420gr", "bowls": 2 },
                { "weight": "40.0 kg", "amount": "380 - 510gr", "bowls": 2 },
                { "weight": "50.0 kg", "amount": "450 - 600gr", "bowls": 2 },
                { "weight": "60.0 kg", "amount": "520 - 685gr", "bowls": 2 },
                { "weight": "70.0 kg", "amount": "585 - 765gr", "bowls": 2 },
                { "weight": "80.0 kg", "amount": "650 - 845gr", "bowls": 2 },
                { "weight": "90.0 kg", "amount": "710 - 920gr", "bowls": 2 }
            ],
        },
        {
            "product": "Cavom compleet diner",
            "product_id": "compleet-diner",
            "color": "yellow",
            "feeding_guide_weight": [
                { "weight": "1.0 kg", "amount": "20 - 30gr", "bowls": 2 },
                { "weight": "5.0 kg", "amount": "75 - 110gr", "bowls": 2 },
                { "weight": "10.0 kg", "amount": "130 - 185gr", "bowls": 2 },
                { "weight": "15.0 kg", "amount": "175 - 250gr", "bowls": 2 },
                { "weight": "20.0 kg", "amount": "220 - 315gr", "bowls": 2 },
                { "weight": "30.0 kg", "amount": "305 - 425gr", "bowls": 2 },
                { "weight": "40.0 kg", "amount": "380 - 530gr", "bowls": 2 },
                { "weight": "50.0 kg", "amount": "450 - 625gr", "bowls": 2 },
                { "weight": "60.0 kg", "amount": "520 - 715gr", "bowls": 2 },
                { "weight": "70.0 kg", "amount": "585 - 805gr", "bowls": 2 },
                { "weight": "80.0 kg", "amount": "650 - 890gr", "bowls": 2 },
                { "weight": "90.0 kg", "amount": "710 - 970gr", "bowls": 2 }
            ],
            "disclaimer": {
                "nl": "Mengen met warm water en Cavom compleet Diner is klaar voor gebruik. De benodigde hoeveelheid hangt o.a. af van ras leeftijd en activiteit van uw hond. Deze waarde is een richtlijn die u zo nodig dient aan te passen.",
                "en": "Mix with warm water, and Cavom Complete Dinner is ready to use. The required amount depends on factors such as breed, age, and activity level of your dog. This value is a guideline that should be adjusted as needed.",
                "de": "Mit warmem Wasser mischen, und Cavom Complete Dinner ist gebrauchsfertig. Die benötigte Menge hängt unter anderem von der Rasse, dem Alter und der Aktivität Ihres Hundes ab. Dieser Wert ist eine Richtlinie, die bei Bedarf angepasst werden sollte."
            }
        },
        {
            "product": "Cavom compleet light",
            "product_id": "compleet-light",
            "color": "purple",
            "feeding_guide_weight": [
                { "weight": "1.0 kg", "amount": "16 - 40gr", "bowls": 2 },
                { "weight": "5.0 kg", "amount": "60 - 110gr", "bowls": 2 },
                { "weight": "10.0 kg", "amount": "110 - 185gr", "bowls": 2 },
                { "weight": "15.0 kg", "amount": "155 - 250gr", "bowls": 2 },
                { "weight": "20.0 kg", "amount": "190 - 310gr", "bowls": 2 },
                { "weight": "25.0 kg", "amount": "230 - 360gr", "bowls": 2 },
                { "weight": "30.0 kg", "amount": "260 - 410gr", "bowls": 2 },
                { "weight": "35.0 kg", "amount": "295 - 460gr", "bowls": 2 },
                { "weight": "40.0 kg", "amount": "325 - 500gr", "bowls": 2 },
                { "weight": "50.0 kg", "amount": "390 - 585gr", "bowls": 2 },
                { "weight": "60.0 kg", "amount": "455 - 670gr", "bowls": 2 },
                { "weight": "70.0 kg", "amount": "515 - 750gr", "bowls": 2 },
                { "weight": "80.0 kg", "amount": "575 - 830gr", "bowls": 2 },
                { "weight": "90.0 kg", "amount": "635 - 905gr", "bowls": 2 }
            ]
        },
        {
            "product": "Cavom compleet lam&rijst",
            "product_id": "compleet-lam-rijst",
            "color": "brown",
            "feeding_guide_weight": [
                { "weight": "1.0 kg", "amount": "20 - 40gr", "bowls": 2 },
                { "weight": "5.0 kg", "amount": "75 - 115gr", "bowls": 2 },
                { "weight": "10.0 kg", "amount": "130 - 190gr", "bowls": 2 },
                { "weight": "15.0 kg", "amount": "175 - 255gr", "bowls": 2 },
                { "weight": "20.0 kg", "amount": "220 - 315gr", "bowls": 2 },
                { "weight": "30.0 kg", "amount": "305 - 420gr", "bowls": 2 },
                { "weight": "40.0 kg", "amount": "380 - 510gr", "bowls": 2 },
                { "weight": "50.0 kg", "amount": "450 - 600gr", "bowls": 2 },
                { "weight": "60.0 kg", "amount": "520 - 685gr", "bowls": 2 },
                { "weight": "70.0 kg", "amount": "585 - 765gr", "bowls": 2 },
                { "weight": "80.0 kg", "amount": "650 - 845gr", "bowls": 2 },
                { "weight": "90.0 kg", "amount": "710 - 920gr", "bowls": 2 }
            ]
        },
        {
            "product": "Cavom compleet midi",
            "product_id": "compleet-midi",
            "color": "blue",
            "feeding_guide_weight": [
                { "weight": "1.0 kg", "amount": "20 - 40gr", "bowls": 2 },
                { "weight": "3.0 kg", "amount": "45 - 75gr", "bowls": 2 },
                { "weight": "5.0 kg", "amount": "75 - 115gr", "bowls": 2 },
                { "weight": "7.5 kg", "amount": "100 - 150gr", "bowls": 2 },
                { "weight": "10.0 kg", "amount": "130 - 190gr", "bowls": 2 },
                { "weight": "12.5 kg", "amount": "150 - 220gr", "bowls": 2 },
                { "weight": "15.0 kg", "amount": "175 - 255gr", "bowls": 2 },
                { "weight": "20.0 kg", "amount": "220 - 315gr", "bowls": 2 },
                { "weight": "25.0 kg", "amount": "260 - 365gr", "bowls": 2 },
                { "weight": "30.0 kg", "amount": "305 - 420gr", "bowls": 2 },
                { "weight": "35.0 kg", "amount": "340 - 465gr", "bowls": 2 },
                { "weight": "40.0 kg", "amount": "380 - 510gr", "bowls": 2 }
            ]
        },
        {
            "product": "Cavom compleet zalm",
            "product_id": "compleet-zalm",
            "color": "salmon",
            "feeding_guide_weight": [
                { "weight": "1.0 kg", "amount": "20 - 40gr", "bowls": 2 },
                { "weight": "5.0 kg", "amount": "75 - 115gr", "bowls": 2 },
                { "weight": "10.0 kg", "amount": "130 - 190gr", "bowls": 2 },
                { "weight": "15.0 kg", "amount": "175 - 255gr", "bowls": 2 },
                { "weight": "20.0 kg", "amount": "220 - 315gr", "bowls": 2 },
                { "weight": "30.0 kg", "amount": "305 - 420gr", "bowls": 2 },
                { "weight": "40.0 kg", "amount": "380 - 510gr", "bowls": 2 },
                { "weight": "50.0 kg", "amount": "450 - 600gr", "bowls": 2 },
                { "weight": "60.0 kg", "amount": "520 - 685gr", "bowls": 2 },
                { "weight": "70.0 kg", "amount": "585 - 765gr", "bowls": 2 },
                { "weight": "80.0 kg", "amount": "650 - 845gr", "bowls": 2 },
                { "weight": "90.0 kg", "amount": "710 - 920gr", "bowls": 2 }
            ]
        },
        {
            "product": "Cavom compleet sport",
            "product_id": "compleet-sport",
            "color": "black",
            "feeding_guide_weight": [
                { "weight": "1.0 kg", "amount": "20 - 40gr", "bowls": 2 },
                { "weight": "5.0 kg", "amount": "75 - 115gr", "bowls": 2 },
                { "weight": "10.0 kg", "amount": "130 - 190gr", "bowls": 2 },
                { "weight": "15.0 kg", "amount": "175 - 255gr", "bowls": 2 },
                { "weight": "20.0 kg", "amount": "220 - 315gr", "bowls": 2 },
                { "weight": "30.0 kg", "amount": "305 - 420gr", "bowls": 2 },
                { "weight": "40.0 kg", "amount": "380 - 510gr", "bowls": 2 },
                { "weight": "50.0 kg", "amount": "450 - 600gr", "bowls": 2 },
                { "weight": "60.0 kg", "amount": "520 - 685gr", "bowls": 2 },
                { "weight": "70.0 kg", "amount": "585 - 765gr", "bowls": 2 },
                { "weight": "80.0 kg", "amount": "650 - 845gr", "bowls": 2 },
                { "weight": "90.0 kg", "amount": "710 - 920gr", "bowls": 2 }
            ]
        }
    ];

    /*
        button
    */

    const normalizedTitle = rawTitle.toString().toLowerCase();

    const findProduct = productData.find( ( product ) =>  {
        
        const id = product.product_id.toLowerCase();

        if ( id === normalizedTitle ) {
            return true;
        }

        if ( id === 'cavom-' + normalizedTitle ) {
            return true;
        }

        return false;

    } );

    let defaultProductID = '';

    if ( findProduct ) {
        defaultProductID = findProduct.product_id;
    }

    const selectedProductID = ref( defaultProductID );
    const selectedWeight = ref( '' );

    const selectedAge = ref( '' );
    const selectedAgeWeight = ref( '' );

    const selectedProduct = computed( () => {

        return productData.find( item => item.product_id === selectedProductID.value );

    } );

    const productDisclaimer = computed( () => {

        if (
            language &&
            selectedProduct.value && 
            selectedProduct.value.disclaimer && 
            selectedProduct.value.disclaimer[language]
        ) {
            return selectedProduct.value.disclaimer[language];
        }
            return '';

    } );

    const selectedProductURL = computed( () => {

        if (
            language &&
            selectedProduct.value
        ) {
            let url = '';
            if ( language == 'nl' ) {
                url = '/product/';
            } else if ( language == 'de' ) {
                url = '/de/produkte/';
            } else if ( language == 'en' ) {
                url = '/en/product/';
            }
            return url + selectedProduct.value.product_id;
        }

        return '';

    } );

    const selectedAmount = computed( () => {

        if ( ! selectedProduct.value ) return null;

        if ( selectedProduct.value.feeding_guide_age && selectedAge.value && selectedAgeWeight.value ) {

            let amountData = selectedProduct.value.feeding_guide_age.find( item => item.age === selectedAge.value );
            
            if ( amountData && ! amountData.hasOwnProperty( 'bowls' ) ) {
                return {
                    "amount" : "reference",
                    "bowls" : ""
                }
            }

            const calcAmount = multiplyFeedingAmount( amountData.amount, parseFloat( selectedAgeWeight.value ) );

            return {
                "amount" : calcAmount,
                "bowls" : amountData.bowls
            }
            
        }

        if ( selectedProduct.value.feeding_guide_weight ) {

            const amount = selectedProduct.value.feeding_guide_weight.find( item => item.weight === selectedWeight.value );
            
            if ( amount ) {
                return amount;
            }
        }

        return null;

    } );

    const resultClass = computed( () => {

        let returnClass = '';

        if ( ! selectedAmount.value ) {
            returnClass += '-inActive';
        }

        if ( selectedProduct.value ) {
            const color = selectedProduct.value.color;
            const pascalCaseColor = color.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join('');
            returnClass += ` -${color} u-bgLight${pascalCaseColor}`;
        } else {
            returnClass += ' -green u-bgLightGreen';
        }

        return returnClass;

    } );
    
    watch( selectedWeight, () => {
        selectedAge.value = '';
        selectedAgeWeight.value = '';
    } );

    watch( selectedProductID, () => {
        selectedAge.value = '';
        selectedAgeWeight.value = '';
    } );

</script>